import { apConfigG } from './third'

/** 处理地理位置 */
export default class ApLocationController {
  /** 当前定位信息 */
  private static nowLocation: ILocation
  /**
   * 获取微信定位信息
   */
  static async init (): Promise<ILocation> {
    return await this.getLocation().catch((error: IPositionError) => {
      return {
        error: true,
        message: error.message
      }
    })
  }
  static getLocation (): Promise<ILocation> {
    return new Promise((resolve, reject) => {
      apConfigG.init(() => {
        apConfigG.getLocation((location) => {
          resolve(location)
        }, () => {
          reject({
            error: true,
            message: '获取定位信息失败'
          })
        })
      })
    })
  }
}
